import { useState, useEffect } from "react";
import Row from "antd/es/row";
import Col from "antd/es/col";
import Drawer from "antd/es/drawer";
import { withTranslation, TFunction } from "react-i18next";
import { useHistory, useLocation } from "react-router-dom";
import {
  HeaderSection,
  LogoContainer,
  Burger,
  NotHidden,
  CustomNavLinkSmall,
  Outline,
  LogoTitle,
  DropdownContainer,
  DropdownTrigger,
  DropdownMenu,
  DropdownItem,
} from "./styles";

const Header = ({ t, i18n }: { t: TFunction; i18n: any }) => {
  const [visible, setVisibility] = useState(false);
  const history = useHistory();
  const location = useLocation();

  // Sync URL with current language on mount and language change
  useEffect(() => {
    const currentLang = i18n.language;
    const searchParams = new URLSearchParams(location.search);
    const langParam = searchParams.get("lang");

    // If language doesn't match URL parameter, update URL
    if (langParam !== currentLang) {
      searchParams.set("lang", currentLang);
      const newSearch = searchParams.toString();
      const newUrl = `${location.pathname}?${newSearch}`;
      history.replace(newUrl);
      console.log("Updated URL to:", newUrl);
    }
  }, [i18n.language, location.pathname, location.search, history]);

  // Close drawer when route changes
  useEffect(() => {
    console.log("Route changed to:", location.pathname);
    console.log("Closing drawer due to route change");
    setVisibility(false);
  }, [location.pathname]);

  useEffect(() => {
    console.log("Drawer visible state changed to:", visible);
  }, [visible]);

  const toggleButton = () => {
    console.log(
      "toggleButton called, current visible:",
      visible,
      "setting to:",
      !visible
    );
    setVisibility(!visible);
  };

  const switchLanguage = () => {
    console.log("switchLanguage called");
    const currentLang = i18n.language;
    const newLang = currentLang === "en" ? "cn" : "en";

    // Change the language in i18n
    i18n.changeLanguage(newLang);

    // Update URL with language parameter for correct meta tags when sharing
    const searchParams = new URLSearchParams(location.search);
    searchParams.set("lang", newLang);
    const newSearch = searchParams.toString();
    const newUrl = `${location.pathname}${newSearch ? "?" + newSearch : ""}`;

    // Update URL without reloading the page
    history.replace(newUrl);
  };

  // Get the brand name based on current language
  const getBrandName = () => {
    return i18n.language === "cn" ? "光影立方" : "LuxBox";
  };

  const MenuItem = () => {
    const handleLanguageSwitch = () => {
      console.log("Language icon clicked, current visible:", visible);
      switchLanguage();
      console.log("Calling setVisibility(false)");
      setVisibility(false);
    };

    return (
      <>
        <CustomNavLinkSmall
          onClick={handleLanguageSwitch}
          style={{ color: "#ffffff", margin: "0.5rem 0", cursor: "pointer" }}
        >
          <img
            src="/img/svg/language.svg"
            alt="Switch Language"
            width="24"
            height="24"
            style={{ cursor: "pointer", filter: "brightness(0) invert(1)" }}
          />
        </CustomNavLinkSmall>
      </>
    );
  };

  const ToolsDropdown = () => {
    return (
      <DropdownContainer>
        <DropdownTrigger>{t("Tools")}</DropdownTrigger>
        <DropdownMenu>
          <DropdownItem to="/viewer">{t("3D Photo Viewer")}</DropdownItem>
        </DropdownMenu>
      </DropdownContainer>
    );
  };

  const ToolsMenuItemMobile = () => {
    const handleViewerClick = () => {
      console.log("3D Photo Viewer clicked, current visible:", visible);
      console.log("Calling toggleButton");
      toggleButton(); // This will flip visible to false
      console.log("Pushing to /viewer");
      history.push("/viewer");
    };

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          marginBottom: "1rem",
        }}
      >
        <div
          style={{
            color: "#ffffff",
            fontSize: "1.4rem",
            fontWeight: 600,
            padding: "8px 0",
            marginBottom: "4px",
          }}
        >
          {t("Tools")}
        </div>
        <div
          onClick={handleViewerClick}
          style={{
            color: "#cccccc",
            fontWeight: 400,
            fontSize: "1.1rem",
            paddingLeft: "1.5rem",
            paddingTop: "6px",
            paddingBottom: "6px",
            margin: 0,
            textDecoration: "none",
            display: "block",
            cursor: "pointer",
          }}
        >
          {t("3D Photo Viewer")}
        </div>
      </div>
    );
  };

  return (
    <HeaderSection>
      <div style={{ paddingLeft: "calc(5% + 4rem)", paddingRight: "5%" }}>
        <Row justify="space-between" align="middle">
          <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
            <LogoContainer to="/" aria-label="homepage">
              <img
                src="/luxbox-yellow.png"
                alt="LuxBox Logo"
                width="50"
                height="50"
                style={{ marginRight: "4px" }}
              />
              <LogoTitle>{getBrandName()}</LogoTitle>
            </LogoContainer>
            <NotHidden>
              <ToolsDropdown />
            </NotHidden>
          </div>
          <NotHidden>
            <MenuItem />
          </NotHidden>
          <Burger onClick={toggleButton}>
            <Outline />
          </Burger>
        </Row>
        <Drawer
          key={`drawer-${visible}`}
          placement="right"
          closable={false}
          open={visible}
          onClose={() => {
            console.log("Drawer onClose called");
            setVisibility(false);
          }}
          maskClosable={true}
          destroyOnClose={true}
          zIndex={2001}
          width={280}
          bodyStyle={{
            backgroundColor: "#000000",
            padding: "1.5rem 1.5rem",
            color: "#ffffff",
            textAlign: "left",
          }}
        >
          <Col style={{ marginBottom: "1.5rem", textAlign: "right" }}>
            <Outline
              onClick={() => {
                console.log("Close icon clicked");
                toggleButton();
              }}
              style={{ cursor: "pointer" }}
            />
          </Col>
          <ToolsMenuItemMobile />
          <MenuItem />
        </Drawer>
      </div>
    </HeaderSection>
  );
};

export default withTranslation()(Header);
